import styled from "styled-components";

/** Shared palette — reuses the Operator UI brand colors. */
export const colors = {
  primary: "#07a568",
  primaryDark: "#003c3c",
  teal: "#1f5454",
  danger: "#cd001a",
  warnBg: "#fff7e0",
  warnBorder: "#f0c419",
  warnText: "#7a5b00",
  cardBorder: "#e2e8e5",
  textMuted: "#5c6b66",
  bg: "#f5f5f5",
};

/** Full-height, single-column shell. Body never scrolls; Main does. */
export const Shell = styled.div`
  display: flex;
  flex-direction: column;
  height: 100dvh;
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  background: ${colors.bg};
`;

export const Header = styled.header`
  flex: 0 0 auto;
  background: #ffffff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.12);
  padding: 10px 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const HeaderTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;

  svg {
    height: 26px;
    width: auto;
  }
`;

export const BrandTitle = styled.span`
  font-weight: 800;
  font-size: 16px;
  color: ${colors.primaryDark};
  white-space: nowrap;
`;

export const Clock = styled.div`
  text-align: right;
  line-height: 1.1;
`;

export const ClockTime = styled.div`
  font-weight: 700;
  font-size: 14px;
  color: ${colors.primaryDark};
`;

export const ClockDate = styled.div`
  font-size: 11px;
  color: ${colors.textMuted};
`;

export const HeaderMetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  min-height: 20px;
`;

export const ConfigName = styled.span`
  font-weight: 600;
  font-size: 12px;
  color: ${colors.textMuted};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ModuleBadge = styled.span`
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${colors.primary};
  background: #e0fbee;
  border-radius: 6px;
  padding: 2px 8px;
`;

export const AccountName = styled.span`
  margin-left: auto;
  font-size: 12px;
  color: ${colors.textMuted};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 45%;
`;

/** Scrollable body region between the header and any bottom action bar. */
export const Main = styled.main`
  flex: 1 1 auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
`;
